import React from "react"

function IconDragAndDrop({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg fill={color} fuze-icon="drag-and-drop" width="24px" height="24px" viewBox="0 0 24 24" {...props}>
      <path d="M19.2,14.4 C19.5313708,14.4 19.8,14.6686292 19.8,15 C19.8,15.2982338 19.5824104,15.5456468 19.2973231,15.592147 L19.2,15.6 L5.2,15.6 C4.86862915,15.6 4.6,15.3313708 4.6,15 C4.6,14.7017662 4.81758961,14.4543532 5.10267688,14.407853 L5.2,14.4 L19.2,14.4 Z M19.2,8.4 C19.5313708,8.4 19.8,8.66862915 19.8,9 C19.8,9.29823376 19.5824104,9.54564675 19.2973231,9.59214701 L19.2,9.6 L5.2,9.6 C4.86862915,9.6 4.6,9.33137085 4.6,9 C4.6,8.70176624 4.81758961,8.45435325 5.10267688,8.40785299 L5.2,8.4 L19.2,8.4 Z"></path>
    </svg>
  )
}

export default IconDragAndDrop
